import { useEffect, useState } from 'react';

const FIREBASE_REALTIME_DATABASE_URL = 'https://whateating-ffb57-default-rtdb.firebaseio.com/roll-count.json';

export default function useRollCount(): [number, unknown] {
  const [count, setCount] = useState(0);
  const [error, setError] = useState(undefined);
  useEffect(() => {
    (async () => {
      try {
        const count = await getCount();
        setCount(count);
      } catch (e) {
        setError(e);
      }
    })();
  }, []);
  return [count, error];
}

export async function increaseCount(): Promise<void> {
  if (process.env.REACT_APP_ENV === 'production') {
    await fetch(FIREBASE_REALTIME_DATABASE_URL, {
      method: 'PUT',
      body: JSON.stringify({ '.sv': { increment: 1 } }),
    });
  } else {
    console.log('[FIREBASE] Count increased.');
  }
}

export async function getCount(): Promise<number> {
  const res = await fetch(FIREBASE_REALTIME_DATABASE_URL);
  const json = await res.json();
  return parseInt(json);
}
